'use client'

import { useRef } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import SafeImage from './SafeImage'
import { services } from '@/data/homepage'

export default function ServicesSlider() {
  const scrollerRef = useRef<HTMLDivElement>(null)

  const scrollBy = (amount: number) => {
    scrollerRef.current?.scrollBy({ left: amount, behavior: 'smooth' })
  }

  return (
    <section className="py-10 md:py-12 bg-white">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-6 gap-4">
          <div>
            <div className="text-[#232f3e] font-bold text-base md:text-lg uppercase tracking-wider mb-1">
              Hizmetlerimiz
            </div>
            <h2
              className="text-2xl md:text-3xl font-bold mb-2"
              style={{
                background: 'linear-gradient(to top right, #014b64, #01124d)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              Ses Yalıtım ve Akustik Panel Hizmetlerimiz
            </h2>
            <p className="text-[#4b5563] max-w-xl text-xs md:text-sm leading-relaxed">
              Ofis, stüdyo, toplantı odası ve çağrı merkezlerinde gürültüyü azaltan
              uygulamalarla mekânları daha verimli hale getiriyoruz.
            </p>
          </div>
          <div className="flex gap-2 shrink-0">
            <button
              type="button"
              aria-label="Sola kaydır"
              onClick={() => scrollBy(-260)}
              className="w-11 h-11 bg-[#c2410c] rounded-full text-white hover:bg-[#9a3412] flex items-center justify-center"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              type="button"
              aria-label="Sağa kaydır"
              onClick={() => scrollBy(260)}
              className="w-11 h-11 bg-[#c2410c] rounded-full text-white hover:bg-[#9a3412] flex items-center justify-center"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>

        <div
          ref={scrollerRef}
          className="flex gap-3.5 overflow-x-auto scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {services.map((service) => (
            <div
              key={service.title}
              className="flex-shrink-0 w-[220px] md:w-[240px] bg-white rounded-lg overflow-hidden shadow border border-gray-100"
            >
              <div className="relative h-[140px] md:h-[150px] overflow-hidden">
                <SafeImage
                  src={service.image}
                  alt={service.title}
                  fill
                  sizes="240px"
                  className="object-cover"
                />
              </div>
              <div className="p-3.5">
                <div className="text-[#b45309] text-[10px] font-medium mb-0.5">Hizmet</div>
                <p className="text-[#232f3e] font-semibold text-sm leading-snug">
                  {service.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
